export default {
  methods: {
    upload(uploadUrl) {
      if (this.$refs.dropzone.getQueuedFiles().length >= 1) {
        this.form.totalUploadCount = this.$refs.dropzone.getQueuedFiles().length
        this.form.currentUploadCount = 1
        this.form.uploadingDocuments = true

        this.$refs.dropzone.setOption('url', uploadUrl)

        this.$refs.dropzone.processQueue()
      } else {
        this.uploadHasCompleted()
      }
    },

    uploadHasCompleted() {
      this.form.uploadingDocuments = false
      this.$emit('uploadHasCompleted')
    },
  },
}
